export default __webpack_public_path__ + "static/media/Banner_Icon.a39f3391.svg";